import { __awaiter } from '../../../external_node_modules/tslib/tslib.es6.js';
import { getUserCountry as getUserCountry$1 } from '../../../external_node_modules/@wg/web2clientapi/platform/WinStore/getUserCountry.js';
import { fetchUserInfo, getUserInfo } from '../../../api/user.js';
import { PLATFORMS } from '../../../constants/platforms.js';
import { UserEntity } from '../../entity/user.entity.js';
import { getMockedWinStoreUserCountry } from './utils/mock.js';
import settings from '../../../settings.js';
import { log } from '../../../utils/logger.js';
import { memoizeAsync } from '../../../utils/memoize.js';

function fetchUserCountry(useClientMocks) {
    return __awaiter(this, void 0, void 0, function* () {
        if (useClientMocks) {
            return yield getMockedWinStoreUserCountry();
        }
        return yield getUserCountry$1();
    });
}
const getUserCountry = memoizeAsync(fetchUserCountry.name, fetchUserCountry);
function getUser(force = false) {
    return __awaiter(this, void 0, void 0, function* () {
        const userInfoFunc = force ? fetchUserInfo : getUserInfo;
        const [userInfo, countryData] = yield Promise.all([userInfoFunc(), getUserCountry(settings.useClientMocks)]);
        const userEntity = new UserEntity(userInfo.spaCountry, countryData, userInfo.accountId, PLATFORMS.WIN_STORE, userInfo.isAccountUncompleted, null, userInfo.regional);
        if (settings.purchaseDisabled) {
            userEntity.disableUserPurchase();
        }
        log('[WinStore]', 'User data has been successfully fetched', userEntity, userInfo, countryData);
        return userEntity;
    });
}
function isAccountCompleted() {
    return __awaiter(this, void 0, void 0, function* () {
        const userInfo = yield fetchUserInfo();
        log('[WinStore]', 'User data has been successfully fetched', userInfo);
        return !userInfo.isAccountUncompleted;
    });
}

export { getUser, isAccountCompleted };
//# sourceMappingURL=user.js.map
